import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  styled,
} from "@mui/material";

// Styled Components for Email Input (Same as Home Page)
const CustomBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#363636",
  padding: "5px",
  borderRadius: "6px",
  width: "100%",
});

const CustomInput = styled(TextField)({
  flex: 1,
  "& .MuiInputBase-root": {
    color: "#fff",
    backgroundColor: "#363636 !important",
    borderRadius: "6px 0px 0px 6px",
    width: "100%",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#363636 !important",
    borderRadius: "6px 0px 0px 6px !important",
    border: "none !important",
    width: "100%",
    "& fieldset": {
      border: "none !important",
    },
    "&:hover fieldset": {
      border: "none !important",
    },
    "&.Mui-focused fieldset": {
      border: "none !important",
    },
  },
  "& .MuiInputBase-input": {
    padding: "10px 14px",
    color: "#fff !important",
    "&::placeholder": {
      color: "rgba(255, 255, 255, 0.6) !important",
      opacity: 1,
    },
  },
  "& .MuiInputLabel-root": {
    color: "#aaa",
  },
});

const CustomButton = styled(Button)({
  backgroundColor: "#4ef4ff",
  color: "#000000",
  borderRadius: "6px",
  padding: "10px 24px",
  fontSize: "1rem",
  fontWeight: 600,
  fontFamily: "Outfit",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#3bd6e0",
    transform: "translateY(-1px)",
  },
  transition: "all 0.3s ease",
});

const FeaturesHeroSection = () => {
  const [email, setEmail] = useState("");

  const handleGetStarted = () => {
    console.log("Email submitted:", email);
    // Handle email submission logic here
  };
  let images = [
    require("assets/images/feature2.png"),
    require("assets/images/feature3.png"),
    require("assets/images/feature4.png"),
    require("assets/images/feature5.png"),
  ];

  return (
    <Container
      maxWidth="xl"
      sx={{ py: { xs: 3, sm: 4, md: 5 }, position: "relative", zIndex: 2 }}
    >
      <Grid
        container
        spacing={{ xs: 3, sm: 4, md: 6 }}
        alignItems="center"
        sx={{ minHeight: "auto", pt: { xs: 2, sm: 3, md: 10 } }}
      >
        {/* Left Section - Content */}
        <Grid item xs={12} md={4}>
          <Box>
            {/* Main Headline */}
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
                fontWeight: 700,
                fontFamily: "Outfit",
                mb: { xs: 2, sm: 3, md: 4 },
                color: "#FFFFFF",
                lineHeight: 1.2,
              }}
            >
              Nutrition That Fits Your Lifestyle
            </Typography>

            {/* Subtitle */}
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                fontWeight: 400,
                fontFamily: "Outfit",
                color: "rgba(255, 255, 255, 0.8)",
                lineHeight: 1.6,
                mb: { xs: 3, sm: 4, md: 5 },
              }}
            >
              Create customized meal plans that fuel your body breakfast, lunch,
              and dinner done smarter.
            </Typography>

            {/* Email Signup Form */}
            {/* <Box sx={{ mb: 4 }}>
              <CustomBox>
                <CustomInput
                  placeholder="Email ID"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  variant="outlined"
                  size="medium"
                />
                <CustomButton
                  onClick={handleGetStarted}
                  variant="contained"
                >
                  Get Started
                </CustomButton>
              </CustomBox>
            </Box> */}

            {/* Bottom Text */}
            <Typography
              sx={{
                fontSize: "1rem",
                fontFamily: "Outfit",
                color: "rgba(255, 255, 255, 0.7)",
              }}
            >
              Empowering 500+ Dietitians to Grow Smarter
            </Typography>
          </Box>
        </Grid>

        {/* Right Section - Meal Plan Display */}
        <Grid item xs={12} md={8}>
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              borderRadius: "20px",
              padding: { xs: "20px", sm: "25px", md: "30px" },
              position: "relative",
              overflow: "hidden",
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              gap: { xs: "15px", sm: "18px", md: "20px" },
            }}
          >
            {/* Left Side - Stacked Cards */}
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "flex-start",
                flexShrink: 0,
              }}
            >
              {/* All Cards - Stacked in row with z-index */}
              {images.map((img, index) => (
                <Box
                  key={index}
                  sx={{
                    position: "relative",
                    width: index === 3 ? "250px" : "100px", // Main card (oatmeal) is bigger
                    height: { xs: "350px", sm: "400px", md: "450px" }, // Responsive height
                    backgroundColor: "#FFFFFF",
                    overflow: "hidden",
                    zIndex: index + 1,
                    marginLeft: index > 0 ? "-40px" : "0px",
                  }}
                >
                  {/* All cards - with white section on left */}
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    {/* White section on left */}
                    <Box
                      sx={{
                        width: index === 3 ? "20%" : "30%", // Less white space for oatmeal card
                        height: "100%",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                    {/* Image section on right */}
                    <Box
                      component="img"
                      src={img}
                      alt={`food-${index}`}
                      sx={{
                        width: index === 3 ? "80%" : "70%", // More image space for oatmeal card
                        height: "100%",
                        borderRadius: "15px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>

            {/* Right Side - Main Content */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: { xs: "350px", sm: "400px", md: "450px" },
              }}
            >
              {/* Top Section - Title and Meal Name */}
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "1.8rem", sm: "2rem", md: "2.2rem" },
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    color: "#242424",
                    mb: 1,
                  }}
                >
                  Breakfast
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: "1rem", sm: "1.05rem", md: "1.1rem" },
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    color: "#4A90E2",
                    mb: 2,
                  }}
                >
                  Oatmeal with Berries
                </Typography>
              </Box>

              {/* Bottom Section - Nutrition Information */}
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "1.3rem", sm: "1.4rem", md: "1.5rem" },
                    fontWeight: 600,
                    fontFamily: "Outfit",
                    color: "#000000",
                    mb: 1,
                  }}
                >
                  Nutrition:
                </Typography>

                <Typography
                  sx={{
                    fontSize: "0.9rem",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    color: "#000000",
                    lineHeight: 1.3,
                    mb: 1,
                  }}
                >
                  350 kcal | High in protein | Ready in 15 min
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    color: "#000000",
                    lineHeight: 1.4,
                  }}
                >
                  Whole grain toast topped with creamy avocado, soft-boiled egg,
                  and a sprinkle of chia seeds.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FeaturesHeroSection;
